import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { t } from '../../i18n/translate.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './FirmwareUpgradeConfirm.module.scss.js';

var FirmwareUpgradeConfirm = function FirmwareUpgradeConfirm(_ref) {
  var instance = _ref.instance;
  var panel = instance.panel,
    onClick = instance.onClick,
    removeSubPanel = instance.removeSubPanel,
    isUpgradingGateway = instance.isUpgradingGateway,
    oldGuiTranslation = instance.oldGuiTranslation,
    newGuiTranslation = instance.newGuiTranslation;
  var dispatch = useDispatch();
  var close = function close() {
    dispatch(removeSubPanel(panel));
  };
  var agree = function agree() {
    onClick();
    close();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper,
    id: "upgrade-firmware-dialog"
  }, /*#__PURE__*/React.createElement("h1", {
    className: classNames('title', styles.title)
  }, t('MPLIB_FIRMWARE_UPDATE')), /*#__PURE__*/React.createElement("p", {
    className: styles.text
  }, isUpgradingGateway ? t('MPLIB_FIRMWARE_UPDATE_GATEWAY_CONFIRM', {
    oldGateway: oldGuiTranslation,
    newGateway: newGuiTranslation
  }) : t('MPLIB_FIRMWARE_UPDATE_CONFIRM')), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonBar
  }, /*#__PURE__*/React.createElement(Button, {
    dataTestId: "cancel-upgrade",
    text: t('MPLIB_CANCEL'),
    onClick: close,
    className: styles.optionButton,
    flat: true,
    cancel: true
  }), /*#__PURE__*/React.createElement(Button, {
    dataTestId: "ok-upgrade",
    text: t('MPLIB_UPGRADE'),
    onClick: agree,
    className: styles.optionButton,
    flat: true
  })));
};
FirmwareUpgradeConfirm.propTypes = {
  instance: PropTypes.shape({
    panel: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    removeSubPanel: PropTypes.func.isRequired,
    isUpgradingGateway: PropTypes.bool.isRequired,
    oldGuiTranslation: PropTypes.string,
    newGuiTranslation: PropTypes.string,
    t: PropTypes.func.isRequired
  }).isRequired
};
FirmwareUpgradeConfirm.defaultProps = {};

export { FirmwareUpgradeConfirm as default };
